import React from 'react';
import * as FontAwesome from 'react-icons/lib/fa';
class Project extends React.Component {
	render(){
		const { details } = this.props;
		const buttonText =  'Visit Site';
		return(
			<div className="project-card">
				<div className="card-top">
					<img src={details.image} alt={details.name} className="project-image"/>
					<div className="project-title">{details.name}</div>
					<div className="sep"></div>
				</div>
				<div className="card-body">
				<div className="project-info"><span>{details.desc}</span></div>
				</div>
				<div className="card-action">
					<a href={details.url} target="_new"><span>{buttonText}</span><span><FontAwesome.FaCaretRight /></span> </a>
				</div>
			</div>
		)
	}
}

Project.propTypes = {
	details: React.PropTypes.object.isRequired
}
export default Project;


/** WEBPACK FOOTER **
 ** ./src/components/Project.js
 **/